const tradeInSteps = {
  step_1: { step: 0, page: 1, maxPage: 10 },
  step_2: { step: 1, page: 2, maxPage: 10 },
  step_3: { step: 2, page: 3, maxPage: 10 },
  step_4: { step: 3, page: 4, maxPage: 10 },
  step_5: { step: 4, page: 5, maxPage: 10 },
  step_6: { step: 5, page: 6, maxPage: 10 },
  step_7: { step: 6, page: 7, maxPage: 10 },
  step_8: { step: 7, page: 8, maxPage: 10 },
  step_9: { step: 8, page: 9, maxPage: 10 },
  step_10: { step: 9, page: 10, maxPage: 10 },
};

export default tradeInSteps;
